// Events
export const TASK_LIST_EVENT_SOURCE_ID = 'TASK_LIST';

// API
export const TASKS_API_ENDPOINT = '/v1/tasks';